export default __webpack_public_path__ + "icon-comment.76940cb5.png";